export default __webpack_public_path__ + "static/media/logo.98d02a52.webp";